import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';
import UnifiedNavPanel from './UnifiedNavPanel';
import SoundEffectsToggle from './SoundEffectsToggle';

const StudentLayout = ({ children, setToken }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (sidebarOpen) {
            setSidebarOpen(false);
        }
    }, [location.pathname]);

    const navItems = [
        { to: "/student/dashboard", label: "Dashboard" },
        { to: "/student/profile", label: "My Profile" },
        { to: "/student/self-check", label: "Self Check" },
        { to: "/student/help", label: "Help Center" }
    ];
    
    const currentPage = navItems.find(item => item.to === location.pathname);

    return (
        <div className="flex h-screen bg-gray-50">
            <UnifiedNavPanel role="user" setToken={setToken} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="fixed right-4 top-4 z-40">
                <SoundEffectsToggle />
            </div>

            {/* Floating open button for desktop when sidebar closed */}
            {!sidebarOpen && (
                <button
                    onClick={() => setSidebarOpen(true)}
                    className="hidden md:block fixed top-4 left-4 z-40 bg-white border rounded-full shadow p-2 text-gray-600 hover:text-gray-800"
                    aria-label="Open navigation"
                >
                    <FiMenu size={20} />
                </button>
            )}

            <div className="min-w-0 flex-1 flex flex-col overflow-hidden">
                {/* Mobile Top Bar */}
                <header className="md:hidden bg-white shadow-sm z-40">
                    <div className="p-4 flex justify-between items-center">
                        <button onClick={() => setSidebarOpen(true)} className="text-gray-600 hover:text-gray-800">
                            <FiMenu size={24} />
                        </button>
                        <h1 className="text-lg font-semibold text-gray-700">{currentPage?.label || 'Menu'}</h1>
                        <div className="w-8"></div>
                    </div>
                </header>

                <main className="min-w-0 flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-4 sm:p-8">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default StudentLayout;
